import JSONAPISerializer from 'json-api-serializer'

export default class SerializerAuthenticated {
  constructor() {
    const serializer = new JSONAPISerializer()

    serializer.register('get-token')

    serializer.register('engineer-sessions', {
      relationships: {
        workOrder: {
          type: 'work-orders',
        },
        mainEngineer: {
          type: 'users',
        },
        engineers: {
          type: 'users',
        },
        activeEngineers: {
          type: 'users',
        },
        workOrderStartWorkCheck: {
          type: 'work-order-start-work-checks',
        },
      },
    })

    serializer.register('hazards')

    serializer.register('maintainable-entities')

    serializer.register('start-work-check-tasks', {
      relationships: {
        hazard: {
          type: 'hazards',
        },
      },
    })

    serializer.register('work-orders')

    serializer.register('work-order-start-work-checks', {
      relationships: {
        workOrder: {
          type: 'work-orders',
        },
        workOrderStartWorkCheckTasks: {
          type: 'work-order-start-work-check-tasks',
        },
      },
    })

    serializer.register('work-order-start-work-check-tasks')

    serializer.register('users')

    serializer.register('work-order-comments', {
      relationships: {
        workOrder: {
          type: 'work-orders',
        },
      },
    })

    return serializer
  }
}
